// src/config/gauges/cotherm2comp.js C1 = C2 

export const cotherm2CompGaugeConfig = [
  // 1) Pres. Succion Comp 1 (igual centrifuga)
  {
    key: "presSuccionComp1",
    title: "Pres. Succion Comp 1",
    unit: "psi",
    min: 0,
    max: 100,
    ranges: [
      { from: 0,  to: 27.99, color: "red" },
      { from: 28, to: 32.99, color: "yellow" },
      { from: 33, to: 40.99, color: "green" },
      { from: 41, to: 68.99, color: "yellow" },
      { from: 69, to: 1000, color: "red" },
    ],
  },

  // 2) Pres. Succion Comp 2 igual que esto :  Pres. Succion Comp 1 (igual centrifuga)
  {
    key: "presSuccionComp2",
    title: "Pres. Succion Comp 2",
    unit: "psi",
    min: 0,
    max: 100,
    ranges: [
      { min: 0,  max: 27.99,  color: "red" },     // Bajo / Alto (Rojo)
      { min: 28, max: 32.99,  color: "yellow" },  // Precaución (Amarillo)
      { min: 33, max: 40.99,  color: "green" },   // Óptimo (Verde)
      { min: 41, max: 68.99,  color: "yellow" },  // Precaución (Amarillo)
      { min: 69, max: 100, color: "red" },     // Muy Alto (Rojo)
    ],
  },

  // 3) Presion Descarga Comp 1
  {
    key: "presionDescargaComp1",
    title: "Presion Descarga Comp 1",
    unit: "psi",
    min: 0,
    max: 300,
    ranges: [
      { from: 0,   to: 190, color: "red" },
      { from: 190.1, to: 209.99, color: "yellow" },
      { from: 210, to: 234.99, color: "green" },
      { from: 235, to: 249.99, color: "yellow" },
      { from: 250, to: 30000, color: "red" },
    ],
  },

  // 4) Presion Descarga Comp 2
  {
    key: "presionDescargaComp2",
    title: "Presion Descarga Comp 2",
    unit: "psi",
    min: 0,
    max: 300,
    ranges: [
      { from: 0,   to: 190, color: "red" },
      { from: 190.1, to: 209.99, color: "yellow" },
      { from: 210, to: 234.99, color: "green" },
      { from: 235, to: 249.99, color: "yellow" },
      { from: 250, to: 30000, color: "red" },
    ],
  },

  // 5) Temp. Proceso Entrada
  {
    key: "tempProcesoEntrada",
    title: "Temp. Proceso Entrada",
    unit: "°C",
    min: 0,
    max: 65,
    ranges: [
      { from: 0,  to: 40.99, color: "red" },
      { from: 41, to: 46.99, color: "yellow" },
      { from: 47, to: 55.99, color: "green" },
      { from: 56, to: 58.99, color: "yellow" },
      { from: 59, to: 65, color: "red" },
    ],
  },

  // 6) Temp. Proceso Salida
  {
    key: "tempProcesoSalida",
    title: "Temp. Proceso Salida",
    unit: "°C",
    min: 0,
    max: 80,
    ranges: [
      { from: 0,  to: 52, color: "red" },
      { from: 52, to: 57, color: "yellow" },
      { from: 57, to: 61, color: "green" },
      { from: 61, to: 63, color: "yellow" },
      { from: 63, to: 80, color: "red" },
    ],
  },

  // 7) Temp. Evap Salida C1  (tevapS_C1) 
  {
    key: "tempEvapSalidaC1",
    title: "Temp. Evap Salida C1",
    unit: "°C",
    min: 0,
    max: 50,
    ranges: [
      { min: 0,  max: 4.99,  color: "red" },      // Muy Bajo
      { min: 5,  max: 6.99,  color: "yellow" },   // Precaución
      { min: 7,  max: 12.99, color: "green" },    // Óptimo
      { min: 13, max: 19.99, color: "yellow" },   // Precaución
      { min: 20, max: 100, color: "red" },      // Alto
    ],
  },

  // 8) Temp. Evap Salida C2  (tevapS_C2)
  {
    key: "tempEvapSalidaC2",
    title: "Temp. Evap Salida C2",
    unit: "°C",
    min: 0,
    max: 50,
    ranges: [
      { min: 0,  max: 4.99,  color: "red" },      // Muy Bajo
      { min: 5,  max: 6.99,  color: "yellow" },   // Precaución
      { min: 7,  max: 12.99, color: "green" },    // Óptimo
      { min: 13, max: 19.99, color: "yellow" },   // Precaución
      { min: 20, max: 100, color: "red" },      // Alto
    ],
  },

  // 9) Temp. Descarga Comp 1
  {
    key: "tempDescargaComp1",
    title: "Temp. Descarga Comp 1",
    unit: "°C",
    min: 0,
    max: 250,
    ranges: [
      { from: 0,   to: 60,  color: "red" },
      { from: 60.1,  to: 65,  color: "yellow" },
      { from: 65.1,  to: 80,  color: "green" },
      { from: 80.1,  to: 90,  color: "yellow" },
      { from: 90.1,  to: 250000, color: "red" },
    ],
  },

  // 10) Temp. Descarga Comp 2
  {
    key: "tempDescargaComp2",
    title: "Temp. Descarga Comp 2",
    unit: "°C",
    min: 0,
    max: 250,
    ranges: [
      { from: 0,   to: 60,  color: "red" },
      { from: 60.1,  to: 65,  color: "yellow" },
      { from: 65.1,  to: 80,  color: "green" },
      { from: 80.1,  to: 90,  color: "yellow" },
      { from: 90.1,  to: 25000, color: "red" },
    ],
  },
];
